// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-field-stastistic .icon{border-radius:100%;background-color:#424242}", ""]);
// Exports
module.exports = exports;
